import { render, staticRenderFns } from "./CreateConsentFormQuestions.vue?vue&type=template&id=1c055d4e&"
import script from "./CreateConsentFormQuestions.vue?vue&type=script&lang=js&"
export * from "./CreateConsentFormQuestions.vue?vue&type=script&lang=js&"
import style0 from "./CreateConsentFormQuestions.vue?vue&type=style&index=0&id=1c055d4e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports